module.exports = __webpack_public_path__ + "img/0.398da5de.webp";